import { AfterViewInit, Component, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { FormGroup } from '@angular/forms';

import { LocalStorageService } from 'src/app/services/local-storage.service';
import { FieldConfig } from '../dynamic-form/dynamicForm.interface';
import * as _ from 'lodash';


@Component({
    selector: 'app-custom-file-uploader',
    templateUrl: './custom-file-uploader.component.html',
    styleUrls: ['./custom-file-uploader.component.scss'],
    standalone: false
})
export class CustomFileUploaderComponent implements AfterViewInit {

  @ViewChild('uploader') uploader?: any;
  @Input() field!: FieldConfig;
  @Input() group!: FormGroup;
  @Input() bypassToken: boolean = false;
  @Output() onValueChangedEvent: EventEmitter<any> = new EventEmitter<any>();
  @Output() onSuccess: EventEmitter<any> = new EventEmitter<any>();
  @Output() onError: EventEmitter<any> = new EventEmitter<any>();

  constructor(private localStorageS: LocalStorageService) { }

  ngAfterViewInit(): void {
    let dropArea = document.querySelector('#droparea') as HTMLElement;
    (document.getElementById('browse') as HTMLElement).onclick = function () {
      (document.getElementsByClassName('e-file-select-wrap')[0].querySelector('button') as HTMLButtonElement).click();
      return false;
    }
  }




  changes(event: any) {
    console.log("FILE CHANGED")
    this.onValueChangedEvent.emit(event)
  }

  success(event: any) {
    console.warn("DFDSGSDG")
    this.onSuccess.emit(event)
  }

  uploadData() {
    this.uploader!.upload(this.uploader!.filesData);
  }

  setUrl(url: string){

    this.uploader!.asyncSettings.saveUrl = url;//`api/public/pdf/load/file/${id}?moduleCode=${moduleCode}`;
    console.log("I PUT THE SHIT ON THE SHIT")
    console.warn(this.uploader?.asyncSettings)
  }

  addHeaders(args: any) {
    console.log(args)
    if(this.bypassToken == false){
      args.currentRequest.setRequestHeader('Authorization', 'Bearer ' + this.localStorageS.getTokens()?.accessToken);
    }
  }
  

  fileUploadFail(event: any) {
    //console.error("\n \n \n FAILED FILE UPLOAD \n \n \n");
    //console.error(event);
    this.onError.emit(event);
  }
}
